// src/i18n/en/groups.js
const groups = {
    name: 'Group |||| Groups',
    fields: {
        name: 'Name',
        description: 'Description',
        hotels: 'Hotels',
        users: 'Users',
        status: 'Status',
        createdAt: 'Created At',
    },
    actions: {
        create: 'Create Group',
        manage_hotels: 'Manage Hotels',
        view_stats: 'View Statistics',
        export: 'Export Data',
        activate: 'Activate',
        deactivate: 'Deactivate',
        archive: 'Archive',
    },
    titles: {
        create: 'Create Group',
        edit: 'Edit Group',
    },
    sections: {
        basic_info: 'Basic Information',
        basic_info_subtitle: 'Basic data and group configuration',
        new_group_title: 'New Group',
        new_group_subtitle: 'Complete the data to create a new group',
    },
    help: {
        name: 'Unique name that identifies the group',
        description: 'Optional group description (max. 500 characters)',
    },
    list: {
        title: 'Groups',
        search: 'Search',
        search_placeholder: 'Name or description...',
    },
    empty: 'No groups',
    empty_help: 'Create your first group to get started',
    access_denied: 'Only SuperAdmins can manage groups.',
    dialogs: {
        delete_title: 'Delete Group',
        delete_message: 'Are you sure you want to delete the group "{{name}}"?',
        delete_generic: 'Are you sure you want to delete this group?',
        delete_warning: 'This action cannot be undone.',
        delete_warning_with_hotels: 'The group "{{name}}" has {{count}} associated hotel(s). Are you sure you want to delete it?',
        delete_cascade_warning: 'This action will affect associated hotels.',
        item_to_delete: 'Item to delete:',
    },
    notifications: {
        activated: 'Group activated successfully',
        deactivated: 'Group deactivated successfully',
        created: 'Group created successfully',
        updated: 'Group updated successfully',
        deleted: 'Group deleted successfully',
    },
    errors: {
        create: 'Error creating the group',
        update: 'Error updating the group',
        delete: 'Error deleting the group',
        load: 'Error loading groups',
    },
};

export default groups;
